export default __webpack_public_path__ + "static/media/pinterest.af9d6c06.svg";